// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress-indicator-component[data-v-3a645df2]{width:100%;display:flex}.progress-indicator-container[data-v-3a645df2]{width:80%;display:flex;align-items:center}.progress-percentage-container[data-v-3a645df2]{width:20%;margin-left:.5rem;margin-right:.5rem}.distance-label[data-v-3a645df2]{font-size:15px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
